module.exports = __webpack_public_path__ + "img/thailand.638a335.webp";